module.exports = __webpack_public_path__ + "4ecca28845a5a132eab321fc037a562a.svg";